import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-64aff3f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Estadísticas de inventario", -1))
const _hoisted_2 = { class: "container card-global" }

import InvetoryStatsBar from '@/views/PortalViews/InventoryViews/InvetoryStatsBar.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'StatsInventoryView.vue',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InvetoryStatsBar, { class: "stat" })
    ])
  ]))
}
}

})